<template>
  <div class="pie-chart chart-container">
    <h3 class="pie-chart-title">{{ title }}</h3>
    <v-skeleton-loader v-if="isLoading" type="image"></v-skeleton-loader>
    <div v-if="chartOptions && !isLoading">
      <v-chart
        v-if="chartOptions"
        ref="chartInstance"
        @finished="chartFinished"
        :option="chartOptions"
        style="height: 275px; width: 480px;"
      />
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";

import { PieChart } from "echarts/charts";
import { CHART_COLORS, CHART_TOOLTIP } from "@/common/constants/charts";
use([
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
]);

const EMITTED_ACTIONS = {
  FINISHED: "finished",
};

export default {
  name: "VerifiedEventsPieGraph",
  props: {
    title: {
      type: String,
      required: false,
    },
    chartData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return this.constructChartOptions();
    },
    chartInstance() {
      return this.$refs.chartInstance;
    },
    isLoading() {
      return !(this.chartData && this.chartData.length);
    },
  },
  methods: {
    chartFinished() {
      this.$emit(EMITTED_ACTIONS.FINISHED, true);
    },
    reloadChart() {
      if (this.$refs.chartInstance) {
        this.$refs.chartInstance.resize();
      }
    },
    constructChartOptions() {
      let option = {
        color: CHART_COLORS,
        grid: {
          right: "50%",
        },
        legend: {
          type: "scroll",
          textStyle: {
            color: "white",
          },
          orient: "vertical",
          left: "right",
        },
        tooltip: Object.assign(CHART_TOOLTIP, {
          trigger: "item",
          formatter: (params) => {
            let total = 0;
            let cur_item = null;
            let _selected = this.chartInstance.getOption().legend[0].selected;
            if (_selected[params.name] === false) return; // no tooltip if legend unchecked.
            for (let i = 0; i < option.series[0].data.length; i++) {
              let item = option.series[0].data[i];
              if (_selected[item.name] !== false) {
                total += item.value; // total amount for percentage
              }
              if (item.name === params.name) {
                cur_item = item;
              }
            }
            if (!cur_item) return;
            return `${cur_item.name} : ${cur_item.value} (${(
              (cur_item.value / total) *
              100
            ).toFixed(2)}%)`;
          },
        }),
        series: [
          {
            type: "pie",
            center: ["35%", "50%"], // shift the pie chart slightly left
            radius: "70%",
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: this.chartData,
          },
        ],
      };
      return option;
    },
  },
  watch: {
    refresh: {
      handler() {
        this.reloadChart();
      },
    },
  },
};
</script>

<style scoped>
.pie-chart {
  color: #fff;
  padding: 0 !important;
}
</style>
